export default "__VITE_ASSET__DKYX6q68__"